"use strict";

function sideCart() {
  var sidecartForm = document.querySelector(".c-side-cart__form");
  if (sidecartForm) {
    var checkoutButton = sidecartForm.querySelector("button");
    checkoutButton.addEventListener("click", function (e) {
      sidecartForm.submit();
    });
  }
}
sideCart();

// Check that Liquid Ajax Cart exists
if ("liquidAjaxCart" in window) {
  // Define a callback for all the Cart Ajax API requests
  // It will be called BEFORE each request is getting performed
  liquidAjaxCart.subscribeToCartAjaxRequests(function (requestState, subscribeToResult) {
    sideCart();
  });
}